export interface IShipmentSalary {
  from?: number | null
  to?: number | null
  shipmentSalary: number | null
  incurredSalary: number | null
}
export interface ICreateCostingGasoline {
  name?: string
  amount: number | null
  availability: string | null
}

export interface ICreateCostingAssumption {
  name: string
  categoryVehicle: string
  categoryVehicleName: string
  indicator: string
}
export interface IUpdateCostingAssumption {
  name: string
  categoryVehicle: string
  categoryVehicleName: string
  indicator: string
}

export interface CostingAssumption {
  _id: string
  name: string
  categoryVehicle: string
  categoryVehicleName: string
  indicator: string
}

export interface ICostingGasoline {
  _id: string
  name: string
  amount: number
  availability: string
}

export interface IUpdateCostingGasoline {
  name?: string
  amount: number | null
  availability: string | null
}

export interface ICreateCosting {
  name: string | null
  typeCommodity: string | null
  targets: string[] | null
  prices: {
    [key: string]: {
      calculatedType: string | null
      priceDetails: {
        type: string[] | null
        amount: number | null
      }[]
    }
  }
}

export interface IEditCosting {
  name: string | null
  typeCommodity: string | null
  targets: string[] | null
  prices: {
    [key: string]: {
      calculatedType: string | null
      priceDetails: {
        type: string[] | null
        amount: number | null
        typeSelected?: { [key: string]: any }[]
      }[]
    }
  }
}

export interface IUpdateCosting {
  type: string
  name: string
  categoryVehicle: { [key: number]: string | null }
  typeMooc: string
  typeCommodity: string
  amount: number
  calculatedType: string
  categoryVehicleDetail?: { [key: number]: any }
}
export interface IDataCosting {
  _id: string
  type: string
  name: string
  categoryVehicle: { [key: number]: string }
  typeMooc: string
  typeCommodity: string
  amount: number
  calculatedType: string
}
export const rulesAddCosting = {
  name: 'required',
  amount: 'required|numeric',
  calculatedType: 'required',
  type: 'required'
}

export const rulesEditCosting = {
  name: 'required',
  amount: 'required|numeric',
  calculatedType: 'required',
  type: 'required'
}
